/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { workflowBuilderProvisioningResource } from '@jira/router-resources__admin-pages-workflows-workflow-builder-provisioning/src/useWorkflowBuilderProvisioning.tsx';
import { workflowDocumentResource } from '@jira/router-resources__admin-pages-workflows-workflow-document/src/workflowDocumentResource.tsx';
import { workflowCapabilitiesResource } from '@jira/router-resources__admin-pages-workflows-workflow-capabilities/src/workflowCapabilitiesResource.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { GENERIC_PROJECT_HORIZONTAL_NAV } from '@jira/navigation-apps__horizontal-nav-selector/src/constants.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { projectSettingsServicedeskIssuetypesWorkflowRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskIssuetypesWorkflowRoute.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { rovoEntitlementResource } from '@jira/router-resources__rovo-entitlement/src/useRovoEntitlementResource.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import { projectWorkflowContextResource } from '@jira/router-resources__project-workflow-context/src/projectWorkflowContextResource.tsx';
import { LazyIssueTypeSettings } from './ui/issue-type/index.tsx';
import WorkflowNavigationPage, {
	LazyWorkflowNavigationSettings,
} from './ui/workflow-navigation/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const getWorkflowBuilderProvisioningResources = () => [workflowBuilderProvisioningResource];

export const projectSettingsServicedeskIssuetypesWorkflowRouteEntry: Route = createEntry(
	projectSettingsServicedeskIssuetypesWorkflowRoute,
	() => ({
		group: 'project-settings-servicedesk',
		// eslint-disable-next-line no-restricted-syntax
		component: WorkflowNavigationPage,

		layout: expValEquals('hix-7127_wfe_layout_to_chromeless_for_service', 'isEnabled', true, false)
			? chromelessLayout
			: serviceProjectLayout,

		navigation: expValEquals(
			'hix-7127_wfe_layout_to_chromeless_for_service',
			'isEnabled',
			true,
			false,
		)
			? undefined
			: {
					horizontal: GENERIC_PROJECT_HORIZONTAL_NAV,
					menuId: MenuIdProjects,
					sidebarId: SidebarIdProjectSettings,
				},

		resources: expValEquals(
			'hix-7127_wfe_layout_to_chromeless_for_service',
			'isEnabled',
			true,
			false,
		)
			? [
					// Delete this resource after hix-7127_wfe_layout_to_chromeless_for_service experiment is over
					// AND usages of projectContextResource have been swapped with projectWorkflowContextResource
					projectContextResource,
					projectWorkflowContextResource,
					workflowCapabilitiesResource,
					workflowDocumentResource,
					...jiraSpaResources(),
					rovoEntitlementResource,
					...getWorkflowBuilderProvisioningResources(),
				]
			: [
					...getServiceDeskSettingsResources(),
					...getWorkflowBuilderProvisioningResources(),
					getConsolidationStateResource(),
				],

		forPaint: expValEquals(
			'hix-7127_wfe_layout_to_chromeless_for_service',
			'isEnabled',
			true,
			false,
		)
			? [LazyWorkflowNavigationSettings]
			: [LazyAtlassianNavigation, LazyIssueTypeSettings],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
